import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import UCSColors from "@ucs/Utils/UCSColors";
import React, { FC } from "react";
import styled, { css } from "styled-components";

export interface ProductLinks {
    url: string;
    name: string;
    isActive: boolean;
}

interface OwnProps {
    links: ProductLinks[];
}

const StyledMenu = styled.div`
    width: 100%;
    text-align: center;
`;

const StyledLink = styled.a`
    display: inline-block;
    text-align: center;
    font-weight: 400;
    color: ${UCSColors.gray00};
    border-bottom: 2px solid ${getColor("primary")};

    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                font-size: 24px;
                min-width: 90px;
                margin: -4px 2px 0;
            `,
            css`
                font-size: 24px;
                min-width: 100px;
                margin: -4px 4px 0;
            `,
            css`
                font-size: 28px;
                min-width: 110px;
                margin: -4px 8px 0;
            `,
            css`
                font-size: 36px;
                min-width: 175px;
                margin: -4px 8px 0;
            `,
            css`
                font-size: 36px;
                min-width: 175px;
                margin: -4px 8px 0;
            `,
        ])};
`;

const titleStyles: TypographyProps = {
    css: css`
        text-transform: uppercase;
        margin-bottom: 16px;
    `,
};

const ProductMenu: FC<OwnProps> = ({ links }) => {
    return (
        <StyledMenu id="category-menu">
            <Typography variant="h5" as="h5" color={UCSColors.gray04} {...titleStyles}>
                {translate("View products by:")}
            </Typography>
            {links &&
                links.map((link, idx) => (
                    <StyledLink
                        // eslint-disable-next-line react/no-array-index-key
                        key={idx}
                        href={`${link.url}#category-menu`}
                        style={
                            link.isActive
                                ? {}
                                : {
                                      borderBottom: `2px solid ${UCSColors.gray07}`,
                                      color: UCSColors.gray04,
                                  }
                        }
                    >
                        <span>{link.name}</span>
                    </StyledLink>
                ))}
        </StyledMenu>
    );
};

export default ProductMenu;
